import { collection, deleteDoc, doc, getDoc, getDocs, serverTimestamp, setDoc } from "firebase/firestore"

export default class FirebaseCommunautes {
  constructor(baseDeDonnees) {
    this.baseDeDonnees = baseDeDonnees
  }

  get bdd() {
    return this.baseDeDonnees.bdd
  }

  recupererIdUtilisateurCourant() {
    return this.baseDeDonnees.recupererIdUtilisateurCourant()
  }

  async journaliserErreurEtRelancer(error, contexte) {
    return this.baseDeDonnees.journaliserErreurEtRelancer(error, contexte)
  }

  async ajouterUneCommunaute(communaute) {
    try {
      await setDoc(doc(this.bdd, "communautes", communaute.id), {
        nom: communaute.nom,
        code: communaute.code,
        description: communaute.description,
        creerA: serverTimestamp(),
        derniereModification: serverTimestamp(),
      })

      const idMembreConnecte = this.recupererIdUtilisateurCourant()

      await this.ajouterUnMembreDansUneCommunite(communaute.id, idMembreConnecte, "admin")
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "ajouterUneCommunaute")
    }
  }

  async recupererCommunautes() {
    try {
      const snapshot = await getDocs(collection(this.bdd, "communautes"))
      const communautes = []

      snapshot.forEach((docSnapshot) => {
        communautes.push({ id: docSnapshot.id, ...docSnapshot.data() })
      })
      return communautes
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererCommunautes")
    }
  }

  async recupererUneCommunaute(idCommunaute) {
    try {
      const docRefCommunaute = doc(this.bdd, "communautes", idCommunaute)
      const snapshot = await getDoc(docRefCommunaute)
      if (snapshot.exists()) {
        return { id: snapshot.id, ...snapshot.data() }
      }
      throw new Error("Communaute non trouvee")
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererUneCommunaute")
    }
  }

  async recupererLesMembresDuneCommunaute(idCommunaute) {
    try {
      const snapshot = await getDocs(collection(this.bdd, "communautes", idCommunaute, "membres"))
      const membres = []

      snapshot.forEach((docSnapshot) => {
        membres.push({ id: docSnapshot.id, ...docSnapshot.data() })
      })
      return membres
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererLesMembresDuneCommunaute")
    }
  }

  async recupererUnMembreDuneCommunaute(idCommunaute, idMembre) {
    try {
      const docRefMembre = doc(this.bdd, "communautes", idCommunaute, "membres", idMembre)
      const snapshot = await getDoc(docRefMembre)
      if (snapshot.exists()) {
        return { id: snapshot.id, ...snapshot.data() }
      }
      throw new Error("Membre non trouve")
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererUnMembreDuneCommunaute")
    }
  }

  async recupererLeRoleDunMembreDansUneCommunaute(idCommunaute, idMembre) {
    try {
      const docRefMembre = doc(this.bdd, "communautes", idCommunaute, "membres", idMembre)
      const snapshot = await getDoc(docRefMembre)
      if (snapshot.exists()) {
        const data = snapshot.data()
        return data.role
      }
      return null
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererLeRoleDunMembreDansUneCommunaute")
    }
  }

  async recupererLeCodeDuneCommunaute(idCommunaute) {
    try {
      const docRefCommunaute = doc(this.bdd, "communautes", idCommunaute)
      const snapshot = await getDoc(docRefCommunaute)
      if (snapshot.exists()) {
        const data = snapshot.data()
        return data.code
      }
      throw new Error("Communaute non trouvee")
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererLeCodeDuneCommunaute")
    }
  }

  async ajouterUnMembreDansUneCommunite(idCommunaute, idMembre, role = "membre") {
    try {
      await setDoc(doc(this.bdd, "communautes", idCommunaute, "membres", idMembre), {
        dateRejoint: serverTimestamp(),
        role,
      })

      await this.baseDeDonnees.pokemons.ajouterCommunauteAuxPokemonsDuMembre(idMembre, idCommunaute)
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "ajouterUnMembreDansUneCommunite")
    }
  }

  async supprimerUneCommunaute(idCommunaute) {
    try {
      return await deleteDoc(doc(this.bdd, "communautes", idCommunaute))
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "supprimerUneCommunaute")
    }
  }

  async supprimerUnMembreDuneCommunaute(idCommunaute, idMembre) {
    try {
      await deleteDoc(doc(this.bdd, "communautes", idCommunaute, "membres", idMembre))

      await this.baseDeDonnees.pokemons.supprimerCommunauteDesPokemonsDuMembre(idMembre, idCommunaute)
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "supprimerUnMembreDuneCommunaute")
    }
  }
}
